import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getDataDescriptionsService = (modelId) => {
    return getData(`maintenance/ddName/get?modelId=${modelId}`);
} 

export const createNewDataDescriptionService = async (payload) => {
    return await putData('maintenance/ddName/create', payload);
}

export const saveDataDescriptionService = (payload) => {
    return postData('maintenance/ddName/update', payload);
}

export const deleteDataDescriptionService = (payload) => {
    return deleteData('maintenance/ddName/delete', payload);
}

// Config APIs
export const getConfigService = (modelId) => {
    return getData(`maintenance/configGroup/get?modelId=${modelId}`);
} 

export const createNewConfigService = (payload) => {
    return putData('maintenance/configGroup/create', payload);
}

export const updateconfigGroupSortService = (payload) => {
    return postData('maintenance/configGroup/updateMultiple', payload);
}

//DD Values APIs
export const createNewDDValueService = async (payload) => {
    return await putData('maintenance/ddValue/create', payload);
}

export const saveDDValueService = async(payload) => {
    return await postData('maintenance/ddValue/update', payload);
}

export const sorrtDDValuesService = async(payload) => {
    return await postData('maintenance/ddName/updateMultiple', payload);
}

export const deleteDDValueService = async(payload) => {
    return await deleteData('maintenance/ddValue/delete', payload);
}

export const deleteDataConfig = async (payload)=>{
    return await deleteData('maintenance/configGroup/delete', payload)
}

export const BatchDdNameValuesInsert = (payload) => {
    return postData('Maintenance/BatchDdNameValuesInsert', payload);
}

